<template>
  <div class="offerLandings">
    <div class="offerLandings__block">
      <h1 class="offerLandings__title">
        <slot name="header">
          Landing Header
        </slot>
        <span class="offerLandings__br">{{$t('home_header_line_1')}} <span class="offerLandings__title-span">{{$t('home_header_line_2')}} <i><img src="../../assets/images/landings/lines-minutes.svg"></i></span></span>
      </h1>
      <div class="offerLandings__descMobile">{{ desc }}</div>
      <CarOfferBullets v-if="car"/>
      <LandingOfferBullets v-else/>
    </div>
    <div class="offerLandings__image" :class="styles"></div>
    </div>
</template>

<script>
import LandingOfferBullets from './LandingOfferBullets.vue'
import CarOfferBullets from './CarOfferBullets.vue'
export default {
  name: 'LandingOffer',
  props: {
    styles: { type: String, default: '' },
    desc: { type: String, default: '' },
    car: { type: Boolean, default: false }
  },
  components: {
    LandingOfferBullets,
    CarOfferBullets
  }
}
</script>
